module.exports = __webpack_public_path__ + "img/y-185.1fbb33d7.png";